import React from 'react'
import '@styles/boot-splash.css'

const BOOT_SPLASH_ID = 'pw-boot-static'

export function dismissBootSplash({ fadeMs = 100 } = {}) {
    const el = document.getElementById(BOOT_SPLASH_ID)
    if (!el) return Promise.resolve()

    el.classList.add('pw-boot--exit')

    return new Promise((resolve) => {
        window.setTimeout(() => {
            el.remove()
            resolve()
        }, fadeMs)
    })
}

const BootSplash = ({ exiting = false }) => {
    return (
        <div
            className={`pw-boot${exiting ? ' pw-boot--exit' : ''}`}
            role="status"
            aria-live="polite"
            aria-label="Pulsawork"
        >
            <div className="pw-boot__content">
                <div className="pw-boot__mark">
                    <div className="pw-boot__ring" aria-hidden="true" />
                    <div className="pw-boot__ring pw-boot__ring--delayed" aria-hidden="true" />
                    <img className="pw-boot__logo" src="/logo192.png" width="48" height="48" alt="" />
                </div>
                <p className="pw-boot__brand">Pulsawork</p>
            </div>
        </div>
    )
}

export default BootSplash
